import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ef29fb8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search-view" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Não há nenhum comentário por aqui", -1))
const _hoisted_3 = {
  key: 2,
  class: "search__content view"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Resultados encontrados")
const _hoisted_5 = {
  key: 0,
  class: "search__results"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "search__tag" }, "Escolas", -1))
const _hoisted_7 = { class: "cards__track" }
const _hoisted_8 = {
  key: 1,
  class: "search__results"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "search__tag" }, "Trilhas", -1))
const _hoisted_10 = { class: "cards__track" }
const _hoisted_11 = {
  key: 2,
  class: "search__results"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "search__tag" }, "Instrutores", -1))
const _hoisted_13 = { class: "cards__track" }
const _hoisted_14 = {
  key: 3,
  class: "search__results"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "search__tag" }, "Treinamentos", -1))
const _hoisted_16 = { class: "list-cards" }
const _hoisted_17 = {
  key: 3,
  class: "shop-empty fallback"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "shop-empty__label" }, "Nenhum resultado foi encontrado.", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalIntroductoryContent = _resolveComponent("ModalIntroductoryContent")!
  const _component_Comment = _resolveComponent("Comment")!
  const _component_content_fallback = _resolveComponent("content-fallback")!
  const _component_CommentsModal = _resolveComponent("CommentsModal")!
  const _component_SearchHeader = _resolveComponent("SearchHeader")!
  const _component_card = _resolveComponent("card")!
  const _component_Slide = _resolveComponent("Slide")!
  const _component_Navigation = _resolveComponent("Navigation")!
  const _component_carousel = _resolveComponent("carousel")!
  const _component_course = _resolveComponent("course")!
  const _component_PaginationDefault = _resolveComponent("PaginationDefault")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.openModalIntroductoryContent && _ctx.course.introductoryContent)
      ? (_openBlock(), _createBlock(_component_ModalIntroductoryContent, {
          key: 0,
          onClose: _ctx.closeModalIntroductoryContent,
          "introductory-content": _ctx.course.introductoryContent
        }, null, 8, ["onClose", "introductory-content"]))
      : _createCommentVNode("", true),
    (_ctx.isCommentsModalOpen)
      ? (_openBlock(), _createBlock(_component_CommentsModal, {
          key: 1,
          onCloseCommentsModal: _ctx.closeCommentsModal,
          title: _ctx.commentModalTitle
        }, {
          default: _withCtx(() => [
            (_ctx.comments.length)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.comments, (comment, index) => {
                  return (_openBlock(), _createBlock(_component_Comment, {
                    key: index,
                    "user-name": comment.userName,
                    comment: comment.message,
                    date: _ctx.toLocaleDateTime(comment.createAt),
                    stars: comment.rating,
                    "user-image": comment.userImage,
                    "content-name": comment.contentName
                  }, null, 8, ["user-name", "comment", "date", "stars", "user-image", "content-name"]))
                }), 128))
              : (_openBlock(), _createBlock(_component_content_fallback, { key: 1 }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                }))
          ]),
          _: 1
        }, 8, ["onCloseCommentsModal", "title"]))
      : _createCommentVNode("", true),
    (
        _ctx.schoolsSearch?.length ||
          _ctx.courseTracksSearch?.length ||
          _ctx.coursesSearch?.length ||
          _ctx.instructorSearch.length
      )
      ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
          _createVNode(_component_SearchHeader, null, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }),
          false
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_carousel, {
                    class: "cards__entity",
                    settings: _ctx.filterSettings,
                    breakpoints: _ctx.filterBreakpoints
                  }, {
                    addons: _withCtx(() => [
                      _createVNode(_component_Navigation, { class: "navigation" })
                    ]),
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.schoolsSearch, (school, index) => {
                        return (_openBlock(), _createBlock(_component_Slide, { key: index }, {
                          default: _withCtx(() => [
                            _createVNode(_component_card, {
                              "entity-title": school.name,
                              entity: school,
                              onClick: ($event: any) => (_ctx.goToSchoolDetails(school.id))
                            }, null, 8, ["entity-title", "entity", "onClick"])
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["settings", "breakpoints"])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.courseTracksSearch?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_carousel, {
                    class: "cards__entity",
                    settings: _ctx.filterSettings,
                    breakpoints: _ctx.filterBreakpoints
                  }, {
                    addons: _withCtx(() => [
                      _createVNode(_component_Navigation, { class: "navigation" })
                    ]),
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courseTracksSearch, (courseTrack, index) => {
                        return (_openBlock(), _createBlock(_component_Slide, { key: index }, {
                          default: _withCtx(() => [
                            _createVNode(_component_card, {
                              "entity-title": courseTrack.title,
                              entity: courseTrack,
                              onClick: ($event: any) => (_ctx.goToCourseTrackDetails(courseTrack.id))
                            }, null, 8, ["entity-title", "entity", "onClick"])
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["settings", "breakpoints"])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.instructorSearch?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_carousel, {
                    class: "cards__entity",
                    settings: _ctx.filterSettings,
                    breakpoints: _ctx.filterBreakpoints
                  }, {
                    addons: _withCtx(() => [
                      _createVNode(_component_Navigation, { class: "navigation" })
                    ]),
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.instructorSearch, (intructor, index) => {
                        return (_openBlock(), _createBlock(_component_Slide, { key: index }, {
                          default: _withCtx(() => [
                            _createVNode(_component_card, {
                              "border-radius": "50%",
                              "entity-image": intructor.image,
                              "entity-title": intructor.name,
                              entity: intructor,
                              onClick: ($event: any) => (_ctx.goToInstructorDetails(intructor.id))
                            }, null, 8, ["entity-image", "entity-title", "entity", "onClick"])
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["settings", "breakpoints"])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.coursesSearch?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("div", _hoisted_16, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.coursesSearch, (course, index) => {
                    return (_openBlock(), _createBlock(_component_course, {
                      key: index,
                      course: course,
                      onOpenIntroductoryContent: ($event: any) => (_ctx.openIntroductoryContent(course)),
                      onLoadCourseCommentsModal: ($event: any) => (_ctx.loadCourseCommentsModal(course)),
                      blocked: _ctx.isCardBlocked(course),
                      onOpenCourse: ($event: any) => (
              _ctx.$router.push({ name: 'course', params: { course_id: course.id } })
            )
                    }, null, 8, ["course", "onOpenIntroductoryContent", "onLoadCourseCommentsModal", "blocked", "onOpenCourse"]))
                  }), 128))
                ]),
                (_ctx.coursesPage)
                  ? (_openBlock(), _createBlock(_component_PaginationDefault, {
                      key: 0,
                      "qt-pages": _ctx.coursesPage,
                      currentPage: Number(_ctx.$route.query.page) || 1,
                      onChangePage: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateQuery(_ctx.$router, 'page', $event)))
                    }, null, 8, ["qt-pages", "currentPage"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createVNode(_component_content_fallback, null, {
            default: _withCtx(() => [
              _hoisted_18
            ]),
            _: 1
          })
        ]))
  ]))
}